var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgLeasingTrends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50784 3.00588V14.3614L3.50588 15.6973L2.50392 14.3614V3.00588C2.50392 2.45251 2.95252 2.00392 3.50588 2.00392C4.05925 2.00392 4.50784 2.45251 4.50784 3.00588ZM6.51177 3.00588V15.0294L3.50588 19.0372L0.5 15.0294V3.00588C0.5 1.34578 1.84578 0 3.50588 0C5.16599 0 6.51177 1.34578 6.51177 3.00588ZM20.6251 18.0784H20.4905H10.4745V1.95887H22.5863V21.1294C22.5863 21.3685 22.4872 21.6072 22.2952 21.7905C22.1025 21.9744 21.8324 22.0854 21.5418 22.0863C21.3211 22.0843 21.0957 21.9899 20.9185 21.8001C20.7389 21.6078 20.627 21.3345 20.6251 21.0364V18.0784ZM8.56076 0.0451322V18.0784H5.55489L5.55488 21.0392L5.5549 21.0439C5.5586 21.8063 5.8425 22.5485 6.36319 23.1062C6.88589 23.666 7.60815 23.9957 8.37742 24H21.5384C22.3096 23.9998 23.0584 23.7077 23.6167 23.1747C24.1766 22.6402 24.5 21.9054 24.5 21.1294V0.0451322H8.56076ZM7.46863 19.9922H8.56076H18.5768V21.1294C18.5768 21.4599 18.6355 21.783 18.7461 22.0863H8.38592C8.16503 22.0844 7.93938 21.9901 7.76202 21.8001C7.58246 21.6078 7.47057 21.3345 7.46863 21.0366V19.9922ZM12.5235 5.96671H20.5373V4.05297H12.5235V5.96671ZM20.5373 9.97454H12.5235V8.0608H20.5373V9.97454ZM12.5235 13.9824H18.5333V12.0686H12.5235V13.9824Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeasingTrends);
export default __webpack_public_path__ + "static/media/leasing-trends.5b009192.svg";
export { ForwardRef as ReactComponent };